import { Component, ErrorInfo, ReactNode } from "react"
import { Heading, Text, VStack } from "@chakra-ui/react"
import * as Sentry from "@sentry/react"

interface Props {
  errorMessage?: ReactNode
  children?: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.captureException(error)
    console.error("Uncaught error:", error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      if (this.props?.errorMessage) return this.props.errorMessage
      return (
        <VStack textAlign="left" display="flex" justifyContent="flex-start" alignItems="flex-start">
          <Heading as="h4" fontSize="md" color="gray.500" whiteSpace="nowrap">
            壞掉了 (|||ﾟдﾟ)..
          </Heading>
          <Text fontSize="sm" color="gray.500">
            請稍後再試或直接聯絡我們，謝謝！
          </Text>
        </VStack>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
